export const whitelabelTextsDe = {
  home: {
    title: 'Verleihen. Buchen. Nutzen.',
    subTitle:
      'Biete und finde Raum und Material.\nFlexibel, nachhaltig und unkompliziert!',
    offerRoomsSection: {
      title: 'Selbst Räume oder Gegenstände anbieten?',
      subTitle:
        'Werde ein Teil von {{appName}} und biete Räume oder Gegenstände von dir oder deiner Organisation anderen an!',
      btnRegisterLabel: 'Jetzt registrieren',
      btnLoginLabel: 'Anmelden'
    }
  },
  footer: {
    fundingNotice: {
      title: 'Förderhinweis',
      description:
        'Das „{{appName}}“ wird von der Stadt Bamberg in Zusammenarbeit mit dem Kreis Mayen-Koblenz entwickelt und betrieben.',
      slr: 'Es ist Teil des <0>Modellprojektes Smart City</0>. Hierbei unterstützt das Bundesministerium für Wohnen, Stadtentwicklung und Bauwesen (BMWSB) 73 Modellkommunen bei der Entwicklung und Umsetzung digitaler Lösungen zur nachhaltigen und integrierten Stadtentwicklung.',
      slrTitle: 'Modellprojekt Smart City'
    }
  },
  about: {
    heading: {
      title: 'Über das {{appName}}',
      description: ''
    },
    easyLanguage: {
      title: 'Informationen in Leichter Sprache',
      description:
        'Hier erklären wir das {{appName}} einfach und verständlich.',
      linkLabel: 'Zur Seite in leichter Sprache',
      linkTitle: 'Zur Seite in leichter Sprache navigieren'
    },
    content: [
      {
        title: 'Was ist das {{appName}}?',
        description:
          'Das „{{appName}}“ soll Raumangebote und verleihbare Materialien für vielfältige Zwecke sichtbar machen. Es steht allen offen, die Räume oder Materialien für ihre Vorhaben benötigen oder anbieten wollen. Dazu gehören vor allem Ehrenamtliche und Kulturschaffende aber auch andere Gruppen, Initiativen, Vereine sowie Privatpersonen.\n\nRäume können beispielsweise für Treffen, Projektarbeit oder Veranstaltungen genutzt werden. Materialien reichen von Werkzeugen bis hin zu Event-Equipment. '
      },
      {
        title: 'Wofür tun wir das?',
        description:
          'Ziel ist es, Suchende und Anbietende unkompliziert zusammenzubringen. So sollen Dinge nachhaltig genutzt und leerstehende Räume allen zugänglich gemacht werden.\n\nDie Plattform bildet den gesamten Prozess ab – von der Suche, über die Anfrage bis zur Buchung und Bezahlung.'
      },
      {
        title: 'Wer steckt hinter {{appName}}?',
        description:
          'Die Plattform wird von der Stadt Bamberg betrieben und ist Teil des Modellprojektes Smart City. Smart City ist ein Förderprogramm des Bundesministeriums für Wohnen, Stadtentwicklung und Bauwesen (BMWSB), in dem 73 Modellkommunen bei der Entwicklung und Umsetzung digitaler Lösungen zur nachhaltigen und integrierten Stadtentwicklung gefördert werden.\n\nIn der Beteiligungsphase des Smart City Programms in Bamberg kam das Bedürfnis nach dieser Plattform vor allem aus der freien Kulturszene, die die Suche nach geeigneten Räumlichkeiten regelmäßig als große Herausforderung sieht. Darauf aufbauend wurde diese Plattform entwickelt, die letztendlich allen Bürgerinnen und Bürgern zu Gute kommt. '
      },
      {
        title: 'Unsere Werte',
        description:
          'Wichtig sind uns Transparenz, Offenheit und die gleichberechtigte Nutzung durch alle Bürgerinnen und Bürger. Wir verstehen uns als Plattform, die das unkomplizierte Buchen von Räumen und Ausleihen von Materialien an einem zentralen Ort ermöglicht.'
      }
    ]
  }
};

export const whitelabelTextsEn = {
  home: {
    title: 'Renting. Booking. Using.',
    subTitle:
      'Offer and find rooms and materials.\nFlexible, sustainable and uncomplicated!',
    offerRoomsSection: {
      title: 'Want to offer rooms or items yourself?',
      subTitle:
        'Become part of {{appName}} and offer rooms or items from you or your organization to others!',
      btnRegisterLabel: 'Register now',
      btnLoginLabel: 'Log in'
    }
  },
  footer: {
    fundingNotice: {
      title: 'Funding note',
      description:
        '{{appName}} is developed and operated by the city of Bamberg in cooperation with the district of Mayen-Koblenz.',
      slr: 'It is part of the <0>Smart City model project</0>. In this context, the Federal Ministry for Housing, Urban Development and Building (BMWSB) supports 73 model municipalities in developing and implementing digital solutions for sustainable and integrated urban development.',
      slrTitle: 'Smart City model project'
    }
  },
  about: {
    heading: {
      title: 'About {{appName}}',
      description: ''
    },
    easyLanguage: {
      title: 'Information in easy-to-read language',
      description:
        'Here we explain {{appName}} in simple, easy-to-understand words.',
      linkLabel: 'Go to the easy-to-read language page',
      linkTitle: 'Navigate to the easy-to-read language page'
    },
    content: [
      {
        title: 'What is {{appName}}?',
        description:
          '{{appName}} makes room offers and rentable materials visible for a wide variety of purposes. It is open to everyone who needs or wants to offer rooms or materials for their projects. This includes above all volunteers and cultural workers, but also other groups, initiatives, associations and private individuals.\n\nRooms can be used, for example, for meetings, project work or events. Materials range from tools to event equipment.'
      },
      {
        title: 'Why are we doing this?',
        description:
          'Our goal is to connect people looking for rooms or materials with those offering them – quickly and easily. In this way, things can be used more sustainably and vacant rooms can be made accessible to everyone.\n\nThe platform covers the entire process – from the search and request through to booking and payment.'
      },
      {
        title: 'Who is behind {{appName}}?',
        description:
          'The platform is operated by the City of Bamberg and is part of the Smart City model project. Smart City is a funding program of the Federal Ministry for Housing, Urban Development and Building (BMWSB), in which 73 model municipalities are supported in developing and implementing digital solutions for sustainable and integrated urban development.\nDuring the participation phase of the Smart City program in Bamberg, the need for this platform came primarily from the independent cultural scene, which regularly faces major challenges in finding suitable spaces. Building on this, the platform was developed and now benefits all citizens.'
      },
      {
        title: 'Our values',
        description:
          'Transparency, openness and equal access for all citizens are especially important to us. We see ourselves as a platform that allows rooms to be booked and materials to be borrowed easily and centrally.'
      }
    ]
  }
};
